import LayoutListSvg from '@assets/images/svg/layout-list.svg';
import React from 'react';

export interface LayoutListIconProps {
    size?: number;
    color?: string;
}

export const LayoutListIcon = React.memo<LayoutListIconProps>(function LayoutListIcon({ size = 24, color = '#1A1A1A' }) {
    return <LayoutListSvg width={size} height={size} color={color} />;
});

export default LayoutListIcon;


